import rawAxios from 'axios'
import axios from '../../../helpers/axios'
import { IExam } from '../../../types'
import fileReader from '../../../helpers/file-reader';

export default {
  async upload(context: IExam, file) {
    if (file.type.indexOf("image") == -1
      && file.type.indexOf("audio") == -1
      && file.type.indexOf("video") == -1) {
      return Promise.reject("File not support")
    }

    await fileReader(file)

    let imageContentType = file.type
    if (imageContentType == "audio/mpeg") {
      imageContentType = "audio/mp3"
    }

    const uploadParams = {
      upload_image: {
        image_file_size: file.size,
        image_content_type: imageContentType
      },
      imagable: {
        type: "Exam",
        id: context.id
      }
    }
    const data = (await axios().post(context.endpoints.images, uploadParams)).data
    if (!data.form) return Promise.reject("Can't upload")
    const formData = new FormData()
    for (let name in data.form) if (data.form.hasOwnProperty(name)) {
      formData.append(name, data.form[name])
    }
    formData.append('file', file)
    await rawAxios.post(data.url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return data.target
  }
}
